module.exports = __webpack_public_path__ + "img/Steor-Icon-01.75ba6c9e.svg";